module.exports = __webpack_public_path__ + "static/img/industry-1.4892390a.png";